"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearChoiceValues = void 0;
exports["default"] = saveConfiguration;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _navigation = require("../utils/navigation");
var _configuratorState = require("../utils/configuratorState");
var _saveApi = require("../api/saveApi");
var _settings = require("../settings");
var _rulesActions = require("./rulesActions");
var _ajaxStatusActions = require("./ajaxStatusActions");
var _actionTypes = require("./actionTypes");
// http://stackoverflow.com/questions/783818/how-do-i-create-a-custom-error-in-javascript
function SaveError(message, validationErrors) {
  if (!message) {
    throw new Error('Cannot create a SaveError: an error message is required');
  }
  this.name = 'SaveError';
  this.message = message;
  this.validationErrors = validationErrors || [];
}
SaveError.prototype = Error.prototype;
var trySave = function trySave() {
  return {
    type: _actionTypes.TRY_SAVE
  };
};
var saveRecoverableFailure = function saveRecoverableFailure(validationMessages) {
  return {
    type: _actionTypes.SAVE_RECOVERABLE_FAILURE,
    validationMessages: validationMessages
  };
};
var validateRequiredOptions = function validateRequiredOptions(choices) {
  return {
    type: _actionTypes.VALIDATE_REQUIRED_OPTIONS,
    choices: choices
  };
};
var clearChoiceValues = exports.clearChoiceValues = function clearChoiceValues() {
  return {
    type: _actionTypes.CLEAR_CHOICE_VALUES
  };
};
function doSaveConfigurationTasks(dispatch, getState, _ref) {
  var clearOnSave = _ref.clearOnSave;
  var _getSettings = (0, _settings.getSettings)(),
    onSaveFailure = _getSettings.onSaveFailure,
    onSaveSuccess = _getSettings.onSaveSuccess,
    productLine = _getSettings.productLine;
  var _getState$configurato = getState().configurator,
    options = _getState$configurato.options,
    choices = _getState$configurato.choices,
    productInfo = _getState$configurato.productInfo,
    pricing = _getState$configurato.pricing;
  return (0, _saveApi.saveConfigurationApi)(options, choices, productInfo.productId).then(function (response) {
    if (response.hasValidationErrors && response.validationMessages) {
      throw new SaveError('Error: please fix your selections and try again.', response.validationMessages);
    }
    if (clearOnSave) {
      dispatch(clearChoiceValues());
    }
    var configurationData = {
      configurationGuid: response.configurationGuid,
      productLine: productLine,
      pricing: pricing
    };

    // If no callback specified, return callback data for promise chain.

    // To remain consistent with `onSaveFailure` behavior, this only returns
    // data for `.then()` if no `onSaveSuccess` callback is specified in the
    // Configurator component's props. Both solutions were gross, I'm sorry.

    if (onSaveSuccess) {
      onSaveSuccess(configurationData);
    }
    return configurationData;
  })["catch"](function (error) {
    // Ideally we'd want to always throw this at the end
    // but that risks breaking existing projects.
    if (!onSaveFailure) {
      throw error;
    }
    var msg;
    if (error.name && error.name === 'SaveError') {
      dispatch(saveRecoverableFailure(error.validationErrors));
      msg = error.message;
    } else {
      msg = "An unexpected error has occurred while attempting to save a configuration: ".concat(error.stack);
    }
    return onSaveFailure(msg, error);
  });
}
function doErrorTasks(dispatch, getState) {
  var _getSettings2 = (0, _settings.getSettings)(),
    onSaveFailure = _getSettings2.onSaveFailure;
  // query again since executeRules will update state with messages
  var optionsWithErrors = (0, _configuratorState.getOptionsWithErrors)(getState().configurator);
  var first = optionsWithErrors[0];
  if (first) {
    (0, _navigation.scrollToOption)(first.id);
  }
  var messages = (0, _configuratorState.getErrors)(optionsWithErrors);
  dispatch(saveRecoverableFailure(messages));
  return onSaveFailure(optionsWithErrors, messages);
}

// I employed a wonky way to report successes and failures. Here is why:
// 1. We have to use old-fashioned callbacks because the Configurator will be used by who-knows-what, and
//    we can't rely on the presence of ES6+ Promises.
// 2. fetch is ES6 Promise-oriented
// 3. To get fetch running a failure callback in EVERY situation an error could occur,
//    I had to makeevery known failure throw a JS Error, so that at the very end,
//    we could handle all known + unknown failures together.

// NOTE: You can omit the `onSaveSuccess` and `onSaveFailure` callbacks in the
// Configurator component's `settings` prop and this will behave like a normal
// promise.
function saveConfiguration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    clearOnSave: true
  };
  return function (dispatch, getState) {
    var runTasks = function runTasks(tasks) {
      return tasks(dispatch, getState, options);
    };
    var choices = getState().configurator.choices;
    dispatch(trySave());
    dispatch(validateRequiredOptions(choices));
    var optionsWithClientSideErrors = (0, _configuratorState.getOptionsWithErrors)(getState().configurator);
    if (!(0, _isEmpty["default"])(optionsWithClientSideErrors)) {
      return runTasks(doErrorTasks);
    }
    dispatch((0, _ajaxStatusActions.beginAjaxLoad)('Saving Configuration'));
    return dispatch((0, _rulesActions.executeRules)()).then(function (validation) {
      var isInvalid = validation.data.messages.some(function (m) {
        return m.type === 'Error';
      });
      return runTasks(isInvalid ? doErrorTasks : doSaveConfigurationTasks);
    }, function (err) {
      return console.log(err);
    }).then(function () {
      dispatch((0, _ajaxStatusActions.endAjaxLoad)());
    });
  };
}
//# sourceMappingURL=saveActions.js.map